import React, { useState } from "react";
import Modal from "components/common/Modal";

interface IChangeEnhancedTableCellsFontPopUpModal {
    onClose(): void;
    onChangeFont(fontSize: number): void;
    fontSize: number;
}

const ChangeEnhancedTableCellsFontPopUpModal: React.FC<IChangeEnhancedTableCellsFontPopUpModal> = (props) => {
    const options = [6, 8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 84,];
    const [fontSize, setFontSize] = useState<number>(props.fontSize);

    return (
        <Modal header={"Change Font Size"}
            isOpen={true}
            controls={
                <>
                    <button
                        className="primary-button"
                        onClick={() => {
                            props.onChangeFont(fontSize as number);
                        }}
                    >
                        Change
                    </button>
                    <button
                        className="secondary-button"
                        onClick={() => {
                            props.onClose();
                        }}
                    >
                        Cancel
                    </button>
                </>}
        >
            <select
                value={fontSize}
                onChange={(e) => setFontSize(Number(e.target.value))}
            >
                {options.map((number) => (
                    <option key={number} value={number}>
                        {number}
                    </option>
                ))}
            </select>
        </Modal>
    )
}

export default ChangeEnhancedTableCellsFontPopUpModal;